/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApplicantsResponse,
  GetCohortsResponse,
  HTTPValidationError,
} from './platformapi.schemas';

import getApplicantsMutator from '../custom-axios-instance';
import getCohortsMutator from '../custom-axios-instance';

/**
 * Get a list of professionals who have applied to work with the corporate client.
 * @summary Get Applicants
 */
export const getApplicants = (cohortId: number, signal?: AbortSignal) => {
  return getApplicantsMutator<GetApplicantsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`,
    method: 'GET',
    signal,
  });
};

export const getGetApplicantsQueryKey = (cohortId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`] as const;
};

export const getGetApplicantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicantsQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicants>>> = ({ signal }) =>
    getApplicants(cohortId, signal);

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplicants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApplicantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicants>>>;
export type GetApplicantsQueryError = void | HTTPValidationError;

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Applicants
 */

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApplicantsQueryOptions(cohortId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of cohorts associated with the corporate client.
 * @summary Get Cohorts
 */
export const getCohorts = (signal?: AbortSignal) => {
  return getCohortsMutator<GetCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`] as const;
};

export const getGetCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohorts>>> = ({ signal }) =>
    getCohorts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getCohorts>>>;
export type GetCohortsQueryError = void | HTTPValidationError;

export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohorts
 */

export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
